export default __webpack_public_path__ + "maps-examples-heatmap-example-thumbnail-960-992cfa5a3b617162a0d706ad49494c91.png";